<template>
    <div class="cd-section" id="features" >
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/20171205_120912.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h1 class="title">LEGACY PARTS</h1>
                        <h3>Products to support your business</h3>
                    </div>
                </div>
            </div>
        </div>
        
        <!--     *********     BLOGS 3      *********      -->
        <div class="blogs-3" v-if="parts != null && parts.length > 0">
            <div class="container">
                <div class="row" style="margin-bottom: 50px;">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Legacy Danfoss - NC25 - EIL - ECI</h2>
                        <h5 class="description">Please <a href="#contact" @click="gConversion()">contact us</a> for full parts listing and availability. Being one of the premiere installers of the Danfoss Controls, we have experience in troubleshooting and supporting all legacy control deployments. We have maintained an extensive inventory of all legacy Danfoss parts which are available for immediate delivery. Danfoss purchased EIL/ECI in the mid-1990s and discontinued manufacturing all EIL / ECI parts. ETC is pleased to provide an extensive inventory of all EIL /ECI parts.</h5>
                        <h5 class="description">For newer parts, please check out our <a href="https://parts.electronictechcorp.com/" class="btn btn-primary" style="">Parts Store <i class="now-ui-icons shopping_cart-simple"></i></a></h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <!-- <h2 class="title">Legacy Parts</h2>
                        <br /> -->
                        <template  v-for="part in parts">
                        <card type="blog" plain :key="part._id">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" v-lazy="part.headerimg"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                        {{part.title}}
                                    </h3>
                                    <p class="card-description" >
                                        <span v-html="part.body"></span>&nbsp;<a href="#contact" @click="gConversion()" class="font-color-primary">Contact us</a> for availability.
                                    </p>
                                    <!-- <div class="author">
                                        <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                        <span>{{article.author}}</span>
                                    </div> -->
                                </div>
                            </div>
                        </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END BLOGS 3      *********      -->
        <!--     *********     BLOGS 3      *********      -->
        <div class="blogs-3" v-if="latest != null && latest.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Latest Articles</h2>
                        <br />
                        <template  v-for="article in latest">
                        <card type="blog" plain :key="article._id">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" v-lazy="article.headerimg" @click="goTo(article._id)"  style="cursor:pointer;"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">{{article.title}}</router-link>
                                    </h3>
                                    <p class="card-description">
                                        {{article.readmore}}
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">Read More</router-link>
                                    </p>
                                    <div class="author">
                                        <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                        <span>{{article.author}}</span>
                                    </div>
                                </div>
                            </div>
                        </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END BLOGS 3      *********      -->
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
  import Contact from './components/Contact'
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
      Contact,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Legacy Danfoss Parts',
      meta: [
        { vmid: 'description', name: 'description', content: 'We have maintained an extensive inventory of all legacy Danfoss parts which are available for immediate delivery.' },
        { vmid: 'keywords', name: 'keywords', content: 'Danfoss nc25, ackess25, ddai8, ddio16, ddio8, i/o expansion board, danfoss remote communication modules, Therm3, RC-2000, RC2000, EIL, EIL RO Board, EIL Analog, Danfoss Legacy, Old Danfoss parts, ECI ' }
      ],
      links: [
                {rel: 'canonical', href: 'https://electronictechcorp.com/legacyparts'}
            ]
    },
    data () {
        return {
            parts: [
                {
                    _id: 'Danfoss NC25 - ACKESS25',
                    headerimg: 'img/legacyfeature.png',
                    title: 'Danfoss NC25 - ACKESS25',
                    body: 'The NC25 was originally developed in the early 1980s as one of the first electronic refrigeration and HVAC control systems. This controller has been used in a variety of different applications from refrigeration racks to industrial boilers and chillers. In the mid-1990s Danfoss discontinued production of this hardware in favor of the next iteration, the Danfoss AKCESS 55. ',
                },
                // {
                //     _id: 'Danfoss NC25 - Akcess 25',
                //     headerimg: 'img/nc25.png',
                //     title: 'Danfoss NC25 - Akcess 25',
                //     body: 'The AKCESS25 has a full set of features for HVAC and refrigeration rack control and monitoring. The modular design allows selection of analog and digital input and output boards to exactly fit an application. Each AKCESS25 provides up to 48 device control points and software algorithms to give refrigeration users options for condenser, defrost and case control.',
                // },
                {
                    _id: 'DDAI8 – Direct Digital Analog Input Board',
                    headerimg: 'img/ddai8tp.png',
                    title: 'DDAI8 – Direct Digital Analog Input Board',
                    body: 'The Direct Digital Analog Input Eight boards are designed as a ratiometric analog input system. The standard board comes equipped with a 10 bit A/D converter and uses a variety of input sensors (pressure, photocell, relative humidity, etc.) (DDAI8-TP - Pressure Transducers & DDAI8-TI – Temperature sensors).',
                },
                {
                    _id: 'DDIO16 & DDIO8 – Direct Digital Input Output (16/8) Board',
                    headerimg: 'img/ddio16.png',
                    title: 'DDIO16 & DDIO8 – Direct Digital Input Output (16/8) Board',
                    body: 'The Direct Digital Input Output Board has sixteen (16/8) output relays for primary series of control with common and both normally open and normally closed dry contacts and (16/8) digital inputs for equipment monitoring. Board addressing allows its use for any group of (16/8) digital inputs or outputs. The DDIO16 mounts in a 5-inch snap track. The DDIO16 connects to the NC25 on the DD bus by a 26-line digital I/O ribbon cable.',
                },
                {
                    _id: 'NC25 I/O Expansion Board',
                    headerimg: 'img/nc25exp.png',
                    title: 'NC25 I/O Expansion Board',
                    body: 'Systems with more than 32 points must use add this board directly to the back of the NC25. This devices allows for a total of (3) DDIO16 boards on the NC25 controller. Additionally, this board is required in order to use the NC25 modem.',
                },
                {
                    _id: 'Danfoss Remote Communication Modules',
                    headerimg: 'img/parts2.png',
                    title: 'Danfoss Remote Communication Modules',
                    body: 'ETC provides the hardware necessary for both analog phone line connections as well as Ethernet communications for remote connectivity and monitoring of your legacy control systems. (COMM-EL120, COMM8, COMM12, COMM9, etc.).',
                },
                {
                    _id: 'Therm3',
                    headerimg: 'img/parts.png',
                    title: 'Therm3',
                    body: 'A three wire temperature sensor consisting of precision resistors and thermistors to produce a resistance change or voltage output that varies linearly with temperature over the selected range. The replacement part for this is the <a href="https://parts.electronictechcorp.com/products/etc-t300-replacement-part-for-the-obsolete-danfoss-therm3" class="font-color-primary" style="color:#444 !important;"><i class="now-ui-icons shopping_cart-simple"></i> ETC-T300</a>.',
                },
                {
                    _id: 'RC-2000',
                    headerimg: 'img/parts2.png',
                    title: 'RC-2000',
                    body: 'The RC-2000 is the main control processing system for ECI network. The RC-2000 can control (64) analog and digital inputs/outputs.',
                },
                {
                    _id: 'EIL RO Board',
                    headerimg: 'img/parts.png',
                    title: 'EIL RO Board',
                    body: 'EIL / ECI Relay Output board with 8 configurable relay out points.',
                },
                {
                    _id: 'EIL Analog Board',
                    headerimg: 'img/parts2.png',
                    title: 'EIL Analog Board',
                    body: 'EIL / ECI Analog Input board with 8 configurable input points. Black housing with dip switches for board addressing.',
                },
                // {
                //     _id: '',
                //     headerimg: 'img/',
                //     title: '',
                //     body: '',
                // },

            ],
            latest: null,
            domain: 'https://api.website.gamsplus.systems',
        }
    },
    mounted() {
        // this.getLatest()
    },
    methods: {
        // track () {
        //     // setTimeout(() => {
        //         this.$ga.page(this.$router)
        //     // }, 1000);
        // },
        getLatest() {
            this.$http.post(this.domain+'/articles/similar/Controls',{
                    'title': '',
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.latest = data.body
                
            })
        },
        goTo(articleID) {
            this.$router.push({ path: '/article', query: { id: articleID }})
            // window.scrollTo(0,0);
        },
        gConversion(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        }
    },
  }
</script>
<style scoped>
@media (max-width: 768px){
    h1.title{
        font-size:5em;
    }
    .projects-5 .card-background {
        margin-bottom: 30px;
    }
    .projects-5 hr {
        margin-bottom: 0px;
    }
}
@media screen and (min-width: 991px){
    h1.title{
        font-size:7em;
    }
}
@media screen and (max-width: 576px){
    h1.title{
        font-size:3.5em;
    }
    
}
</style>